import { SET_FIRM_NAME_AND_LOGO } from "../actionTypes/firmActionTypes";

export const setFirmNameAndLogo = (data: any) => {
  return {
    type: SET_FIRM_NAME_AND_LOGO,
    payload: data,
  };
};
